import { TeamsTabContentConfig } from '../../state/teams/types';
import { YammerTeamsState } from '../../state/types';

const getTeamsTabContentConfig = (state: YammerTeamsState) => state.teamsConfig.teamsTabContentConfig;

type GetTeamsTabContentType = (state: YammerTeamsState) => TeamsTabContentConfig['teamsTabContentType'];
export const getTeamsTabContentType: GetTeamsTabContentType = (state) =>
  getTeamsTabContentConfig(state).teamsTabContentType;

type GetTeamsTabContentId = (state: YammerTeamsState) => TeamsTabContentConfig['teamsTabContentId'];
export const getTeamsTabContentId: GetTeamsTabContentId = (state) => getTeamsTabContentConfig(state).teamsTabContentId;
